export const TYPE_LABEL = { incoming: 'Incoming', outgoing: 'Outgoing', missed: 'Missed', rejected: 'Rejected' };
export const TYPE_CLASS = { incoming: 'badge badge-ok', outgoing: 'badge badge-plain', missed: 'badge badge-danger', rejected: 'badge badge-danger' };

export function fmtDuration(sec) {
  if (!sec) return '0s';
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  return [h && `${h}h`, (h || m) && `${m}m`, `${s}s`].filter(Boolean).join(' ');
}
